/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-23 15:00:00
 *
 *******************************************************/
//@flow

import React, { useCallback, useState } from 'react';
import { Icon, ActionList, Popover } from '@shopify/polaris';
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons';

export function GuideMenu({ i18n, onShowGuide, onCloseGuide }) {
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive(active => !active), []);

  const activator = (
    <div className="GuideMenu__Activator" onClick={toggleActive}>
      <Icon source={MobileHorizontalDotsMajor} tone="base" onClick={toggleActive} disclosure />
    </div>
  );

  return (
    <div className="GuideMenu">
      <Popover active={active} activator={activator} onClose={toggleActive}>
        <ActionList
          actionRole="menuitem"
          sections={[
            {
              items: [
                {
                  content: i18n.translate('AdminHTML.DashboardV3.QuickStartGuideV2.btn_show_guide'),
                  onAction: onShowGuide
                },
                {
                  content: i18n.translate(
                    'AdminHTML.DashboardV3.QuickStartGuideV2.btn_close_guide'
                  ),
                  onAction: onCloseGuide
                }
              ]
            }
          ]}
        />
      </Popover>
    </div>
  );
}
